export const createListItem = (className, text = ``) => {
  const li = document.createElement(`li`);
  li.className = className;
  li.innerHTML = text;

  return li;
};
